import { render } from "./LinkRichText.vue?vue&type=template&id=e94bf78a"
import script from "./LinkRichText.vue?vue&type=script&lang=js"
export * from "./LinkRichText.vue?vue&type=script&lang=js"

import "./LinkRichText.vue?vue&type=style&index=0&id=e94bf78a&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__